import styled, { css } from 'vue-styled-components';
import { always, prop } from 'ramda';
import { styleWhenTrue } from '../../../utils/styling';
import { COLORS } from '../../../colors';

export const ProviderContainer = styled.div`
  position: relative;
`;

export const TooltipListContainer = styled('div', { showTooltip: Boolean })`
  opacity: ${({ showTooltip }) => (showTooltip ? 1 : 0)};
  pointer-events: ${({ showTooltip }) => (showTooltip ? 'all' : 'none')};
  transition: opacity 200ms ease-in-out;
`;

export const TooltipContainerBase = styled('div', { x: Number, y: Number, showOnLeft: Boolean })`
  position: absolute;
  left: ${prop('x')}px;
  top: ${prop('y')}px;
  ${({ showOnLeft }) =>
    styleWhenTrue(
      always(
        css`
          transform: translateX(-100%);
        `
      )
    )(showOnLeft)}
`;

export const TooltipContainer = styled(TooltipContainerBase)`
  background: #fff;
  box-shadow: 0.1em 0.1em 0.2em ${COLORS.ALTO}, -0.05em -0.05em 0.1em ${COLORS.ALTO};
  border-radius: 4px;
  box-sizing: border-box;
`;
